import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RepliesPerOptionComponent } from './replies-per-option.component';
import { RepliesPerOptionService } from './replies-per-option.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap';
import { PhoneNumberModule } from '@schoolbelle/common/phone-number';

@NgModule({
  declarations: [
    RepliesPerOptionComponent
  ],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    PhoneNumberModule.forRoot(),
  ],
  providers:[
    RepliesPerOptionService,
  ],
  entryComponents: [
    RepliesPerOptionComponent,
  ]
})
export class RepliesPerOptionModule { }
